import defaultValue from "./CompanySearchSlice";

export default defaultValue;
export * from "./CompanySearchSlice";
export * from "./CompanySearchSlice.types";
